var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "block_inp internal_doc p-3" }, [
    _c("div", { staticClass: "form-group mt-2" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "advanced_name" } },
        [_vm._v("\n            Номер *\n        ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "input-group flex-nowrap" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.doc.number,
              expression: "doc.number",
            },
          ],
          staticClass: "form-control",
          attrs: { id: "advanced_name", type: "text" },
          domProps: { value: _vm.doc.number },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.doc, "number", $event.target.value)
            },
          },
        }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group mt-2" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "advanced_name" } },
        [_vm._v("\n            Тема*\n        ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "input-group flex-nowrap" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.doc.title,
              expression: "doc.title",
            },
          ],
          staticClass: "form-control",
          attrs: { id: "advanced_name", type: "text" },
          domProps: { value: _vm.doc.title },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.doc, "title", $event.target.value)
            },
          },
        }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group mt-2" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "advanced_name" } },
        [_vm._v("\n            Дата документа*\n        ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input-group flex-nowrap" },
        [
          _c("date-picker", {
            attrs: {
              "value-type": "format",
              lang: _vm.d_lang,
              confirm: "",
              "first-day-of-week": 1,
            },
            model: {
              value: _vm.doc.doc_date,
              callback: function ($$v) {
                _vm.$set(_vm.doc, "doc_date", $$v)
              },
              expression: "doc.doc_date",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group mt-2" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "advanced_name" } },
        [_vm._v("\n            Стислий опис*\n        ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input-group flex-nowrap" },
        [
          _c("vue-editor", {
            staticClass: "w-100",
            attrs: { "editor-toolbar": _vm.editor_rules, id: "trip_preamblua" },
            model: {
              value: _vm.doc.description,
              callback: function ($$v) {
                _vm.$set(_vm.doc, "description", $$v)
              },
              expression: "doc.description",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "template mt-5 pt-5" },
      [
        _c("organization_select", {
          attrs: { active_id: parseInt(_vm.doc.tov_id) },
          on: { on_organization_set: _vm.set_org_id },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "form-group mt-4" }, [
      _c("label", { staticClass: "form-label" }, [
        _vm._v("\n            Тип документа*\n        "),
      ]),
      _vm._v(" "),
      _vm.doc_types.length > 0
        ? _c(
            "div",
            {},
            [
              _c(
                "v-select",
                {
                  staticClass: "imc_reasons",
                  attrs: {
                    reduce: (active_doc) => active_doc.id,
                    label: "title",
                    options: this.doc_types,
                    filterable: false,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "option",
                        fn: function (option) {
                          return [
                            _c("div", { staticClass: "d-center" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(option.title) +
                                  "\n                    "
                              ),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    706905049
                  ),
                  model: {
                    value: _vm.doc.type_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.doc, "type_id", $$v)
                    },
                    expression: "doc.type_id",
                  },
                },
                [
                  _c("template", { slot: "no-options" }, [
                    _vm._v(
                      "\n                    Оберіть Тип(и)\n                "
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }